// @material-ui/core
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  withMobileDialog
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Close as CloseIcon } from "@material-ui/icons";
import PropTypes from "prop-types";
import React from "react";
import { compose } from "redux";
import MainButton from "../button/MainButton";

const styles = theme => ({
  root: {
    // zIndex: theme.zIndex.modal
  }
});

class FullDialog extends React.Component {
  static propTypes = {
    button: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    onAction: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,

    fullScreen: PropTypes.bool,
    subtitle: PropTypes.string,
    title: PropTypes.string
  };

  state = {
    open: this.props.open
  };

  render() {
    const {
      button,
      children,
      classes,
      color,
      fullScreen,
      icon,
      onAction,
      onClose,
      open,
      subtitle,
      title
    } = this.props;

    return (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        classes={{ root: classes.root }}
        aria-labelledby="form-dialog-title">
        <IconButton
          className="close-button"
          aria-label="close"
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
        {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          {subtitle && <DialogContentText>{subtitle}</DialogContentText>}
          {children}
        </DialogContent>
        <MainButton
          onClick={onAction}
          colored={color}
          fullWidth
          raised
          icon={icon}>
          {button}
        </MainButton>
      </Dialog>
    );
  }
}

export default compose(withMobileDialog(), withStyles(styles))(FullDialog);



// WEBPACK FOOTER //
// ./src/library/dialog/FullDialog.js